import api from '@/services/api'
export async function postsendSNS(params){
    const { data: res } = await api.post('/sendSNS', params) 
    return res
}